import { render, staticRenderFns } from "./file-upload.component.vue?vue&type=template&id=3761b0f7"
import script from "./file-upload.component.ts?vue&type=script&lang=ts&external"
export * from "./file-upload.component.ts?vue&type=script&lang=ts&external"
import style0 from "./file-upload.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports